// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false

// Cookie
Vue.use(require('vue-cookie'))

// Vue-meta
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

// Vuex
import store from './store'

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-22606062-4',
  router
})


/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js